import React, { useRef } from 'react';
var VeltNotificationsPanelContentListItemAvatar = function (props) {
    var notification = props.notification, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-content-list-item-avatar", { ref: ref, notification: notification ? (typeof notification === "string" ? notification : JSON.stringify(notification)) : undefined }, children));
};
export default VeltNotificationsPanelContentListItemAvatar;
